import { ShapeProps } from '@/components/icons/types';

export const ThumbSmall = ({ className }: ShapeProps) => (
    <svg
        className={className}
        width="92"
        height="110"
        viewBox="0 0 92 110"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M74.5411 9.09692C77.7788 11.0894 84.5531 15.9709 85.7486 19.5573M68.5637 6.10824C62.7109 4.24031 48.0165 0.87805 36.0618 2.37239C24.1071 3.86673 12.4015 12.9571 8.04297 17.3155"
            stroke="#C8F134"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M38.3036 9.47025C32.3263 10.8401 19.9233 14.3268 18.1301 17.3155C15.8886 21.0514 7.66969 27.0287 5.0546 34.1268C2.4395 41.2249 0.945166 53.9268 1.69234 55.7948"
            stroke="#C8F134"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M45.4023 8.72308C51.3797 8.97214 64.9782 10.9646 71.5533 16.9419C79.7721 24.4136 86.4967 35.9948 87.2438 40.8514C87.991 45.708 90.2325 61.7721 89.8589 67.3759C89.5601 71.8589 88.9872 77.4627 88.7382 79.7042"
            stroke="#C8F134"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M55.1147 32.6328C51.7524 30.8894 43.1599 28.4487 35.6882 32.6328M30.4581 26.2817C35.3147 24.5383 47.0452 21.8734 55.1147 25.1609C65.2014 29.2704 70.4316 35.9948 71.5524 40.4778C72.6731 44.9608 76.7826 56.9155 76.0354 62.5193C75.2882 68.1231 71.456 87.7693 69.6845 93.5268C68.1901 98.3834 65.4505 103.738 64.8279 106.229M82.7599 62.5193C82.1373 68.2476 80.5184 81.2732 79.0241 87.5495C77.5297 93.8257 74.4165 100.127 73.0467 102.493M29.3373 35.9948C27.2203 39.4816 22.9116 48.2483 22.6128 55.4212C22.2392 64.3872 24.1071 71.8589 19.9977 76.7155C15.8882 81.5721 14.3939 86.0551 10.2845 87.5495M82.0128 54.674C82.0128 53.5532 80.892 40.4778 74.1675 28.8967C68.7879 19.6318 53.2467 16.0702 46.1486 15.4476C41.043 15.6967 30.0098 16.9419 26.7222 19.9306C22.6128 23.6665 12.1524 31.8853 10.2845 41.9721C8.79014 50.0416 8.1675 59.0325 8.04297 62.5193"
            stroke="#C8F134"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M24.1079 33.0061C20.9947 35.7457 14.843 43.7653 15.1418 53.9268C15.5154 66.6287 15.5155 68.8702 12.9004 71.4853"
            stroke="#C8F134"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M38.6765 55.419C38.552 52.4303 39.5731 46.3782 44.6538 46.0794C51.0048 45.7058 52.8728 50.9382 52.8728 53.1775C52.8728 55.419 51.7307 75.0718 49.5106 83.0642C47.6426 89.7887 40.1709 101.743 35.3143 106.974M46.1483 54.3004C45.1521 60.6521 42.8608 74.3263 41.6653 78.2098C40.1709 83.0642 31.5785 103.242 25.6011 105.108M38.6765 61.3985C38.0539 66.7518 36.0615 78.5794 33.0728 83.0642C29.337 88.6702 23.7332 98.0098 17.7559 99.8777M61.8389 37.4891C64.0804 41.474 68.4887 51.8347 68.1898 61.3985C67.8162 73.3532 63.3332 86.4287 61.8389 90.9117C60.6434 94.4981 57.6049 103.114 56.2351 106.974"
            stroke="#C8F134"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M13.6465 95.3947C15.2654 94.0249 19.325 90.7623 22.6125 88.6702C26.722 86.0551 30.8314 68.8702 31.9521 62.5193C33.0729 56.1683 32.3257 47.5761 33.4465 44.5875C34.5672 41.5988 38.3031 35.995 46.8955 36.3686C53.7695 36.6675 57.4804 42.9686 58.4767 46.0818C59.2238 53.8025 60.2699 71.2611 58.4767 79.3306C56.2351 89.4174 48.3899 105.482 45.0276 107.723"
            stroke="#C8F134"
            strokeWidth="3"
            strokeLinecap="round"
        />
    </svg>
);
